import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html'
})
export class HomeComponent implements OnInit {
  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
  }

  handleSpeakersButtonClick():void {
    this.router.navigate(["about"]);
  }

  handleRegisterButtonClick():void {
    this.router.navigate(["about"]);
  }

  registerLink = "https://www.tickettailor.com/events/iowacodecamp/1300554";
  speakersLink = "https://sessionize.com/iowa-code-camp-fall-2024";
}
